declare const process: {
    env: {
        REACT_APP_ENV?: string;
        REACT_APP_API_URL?: string;
        REACT_APP_CHAT_API_URL?: string;
        REACT_APP_CHAT_UI_URL?: string;
        REACT_APP_KEYCLOAK_URL?: string;
    };
};

type Environment = 'local' | 'production';

const ENV: Environment = (process.env.REACT_APP_ENV as Environment) || 'local';

const API_URLS: Record<Environment, string> = {
    local: 'http://localhost:8082',
    production: 'https://be.nutosoft.com',
};

const CHAT_API_URLS: Record<Environment, string> = {
    local: 'http://localhost:8083',
    production: 'https://agentic-be.nutosoft.com',
};

const CHAT_UI_URLS: Record<Environment, string> = {
    local: 'http://localhost:3001',
    production: 'https://agentic-ui.nutosoft.com',
};

const KEYCLOAK_URLS: Record<Environment, string> = {
    local: 'http://localhost:8180/auth',
    production: 'https://identity.nutosoft.com',
};

export const API_BASE_URL: string = process.env.REACT_APP_API_URL || API_URLS[ENV];
export const CHAT_API_BASE_URL: string = process.env.REACT_APP_CHAT_API_URL || CHAT_API_URLS[ENV];
export const CHAT_UI_URL: string = process.env.REACT_APP_CHAT_UI_URL || CHAT_UI_URLS[ENV];
export const KEYCLOAK_URL: string = process.env.REACT_APP_KEYCLOAK_URL || KEYCLOAK_URLS[ENV];
